export default "__VITE_ASSET__iQbc3hNI__"